export default __webpack_public_path__ + "static/media/main1.64249b65.jpg";